<div class="lay-wrapper">
  <div class="header"></div>
  <div class="header-text">
    <h2>{{ "navigation.glossary" | translate }}</h2>
  </div>
  <div class="content">
    <div class="container">
      <div class="cards">
        @for (item of teaserItems; track item; let i = $index) {
          <app-home-card
            [teaserBox]="item.teaser"
            (click)="selectItem(item.item)"
            [ngStyle]="{ background: item.teaser.backgroundColor }"
            [ngClass]="{ clicked: item.item === selectedItem }"
            [shadow]="'lg'">
            <div class="tab-container">
              <div class="tab-body" [style.color]="item.teaser.fontColorText">
                <span class="editor-text" [innerHTML]="currentLanguage === 'en' ? item.item.description : item.item.descriptionDe"></span>
              </div>
            </div>
          </app-home-card>
          @if (item.item === selectedItem) {
            <div
              class="teaser-placeholder"
              (click)="selectItem(item.item)"
              [ngStyle]="{ background: item.teaser.backgroundColor }"
            ></div>
          }
        }
      </div>
    </div>
  </div>
</div>
